export default function Hero() {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section 
      className="relative min-h-screen flex items-center justify-center pt-20 overflow-hidden"
      style={{
        backgroundImage: `linear-gradient(to right, rgba(147, 51, 234, 0.95) 0%, rgba(147, 51, 234, 0.85) 40%, rgba(59, 130, 246, 0.3) 100%), url('https://static.readdy.ai/image/d89a0480eb41114b9dab96ac9b2db3c5/35a6d9210d2916d339f86f5b6d3b6931.jpeg')`,
        backgroundSize: 'cover',
        backgroundPosition: 'center'
      }}
    >
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-white/20"></div>
      
      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8 w-full">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div className="text-left">
            <div className="inline-block mb-6">
              <span className="bg-white/20 backdrop-blur-sm text-white px-6 py-2 rounded-full text-sm font-medium border border-white/30">
                <i className="ri-flashlight-fill mr-2"></i>
                Full-Service Digital Agency
              </span>
            </div>
            
            <h1 className="text-5xl lg:text-7xl font-bold text-white mb-6 leading-tight">
              Your Vision,
              <br />
              <span className="bg-gradient-to-r from-blue-300 to-purple-300 bg-clip-text text-transparent">
                Our Innovation
              </span>
            </h1>
            
            <p className="text-xl text-white/90 mb-8 leading-relaxed max-w-xl">
              DynastyForge specializes in website design, development, mobile app creation, 3D & 4K animation, server setup, and community growth. We build high-performing digital solutions that convert.
            </p>
            
            <div className="flex flex-wrap gap-4">
              <button 
                onClick={scrollToContact}
                className="bg-white text-purple-600 px-8 py-4 rounded-full font-semibold hover:shadow-2xl transition-all cursor-pointer whitespace-nowrap group"
              >
                Start Your Project
                <i className="ri-arrow-right-line ml-2 group-hover:translate-x-1 transition-transform inline-block"></i>
              </button>
              <button 
                onClick={() => {
                  const element = document.getElementById('portfolio');
                  if (element) element.scrollIntoView({ behavior: 'smooth' });
                }}
                className="bg-white/10 backdrop-blur-sm text-white px-8 py-4 rounded-full font-semibold border-2 border-white/30 hover:bg-white/20 transition-all cursor-pointer whitespace-nowrap"
              >
                View Our Work
              </button>
            </div>

            <div className="mt-12 flex items-center gap-8">
              <div>
                <div className="text-4xl font-bold text-white">500+</div>
                <div className="text-white/80 text-sm">Projects Delivered</div>
              </div>
              <div className="h-12 w-px bg-white/30"></div>
              <div>
                <div className="text-4xl font-bold text-white">98%</div>
                <div className="text-white/80 text-sm">Client Satisfaction</div>
              </div>
              <div className="h-12 w-px bg-white/30"></div>
              <div>
                <div className="text-4xl font-bold text-white">24/7</div>
                <div className="text-white/80 text-sm">Support Available</div>
              </div>
            </div>
          </div>

          <div className="hidden lg:block">
            {/* Right side is part of the background image */}
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-3xl text-white/60"></i>
      </div>
    </section>
  );
}
